// Display helpers for insurance plans returned by /api/insurance.

const insurers = { ABHI: 'Aditya Birla Health Insurance' };
const providers = { AAI: 'Across Assist', BOXX: 'BOXX Cyber', BRB: 'Blue Ribbon Bags', ZETEXA: 'Zetexa eSIM' };

export const insurerName = (code) => insurers[code] || code || 'Insurer';
export const providerName = (code) => providers[String(code).split(/[ _]/)[0]] || code;

/** "GOLD_PLUS" → "Gold Plus"; already readable names are kept. */
export function planTitle(plan) {
  const name = plan?.name || '';
  return /^[A-Z0-9_ ]+$/.test(name)
    ? name.split(/[_ ]+/).filter(Boolean).map((w) => w[0] + w.slice(1).toLowerCase()).join(' ')
    : name;
}

/** "$100,000" → 100000, for sorting and filtering. */
export const coverValue = (plan) => Number(String(plan?.coverAmount || '').replace(/[^0-9.]/g, '')) || 0;

export const regionTitle = (name) => (name && /^[A-Z ]+$/.test(name) ? name[0] + name.slice(1).toLowerCase() : name);

/** Benefits worth showing on a plan card: supplier-highlighted first, then insurance covers with a sum insured. */
export function keyBenefits(plan, count = 5) {
  const benefits = plan?.benefits || [];
  const ranked = [
    ...benefits.filter((b) => b.highlighted),
    ...benefits.filter((b) => !b.highlighted && b.type === 'Insurance' && b.sumInsured),
    ...benefits.filter((b) => !b.highlighted && !(b.type === 'Insurance' && b.sumInsured)),
  ];
  const seen = new Set();
  return ranked.filter((b) => (seen.has(b.name) ? false : seen.add(b.name))).slice(0, count);
}

/** Benefits grouped by category ("Medical Covers", "Travel Assistance"…), insurance covers first. */
export function groupBenefits(plan) {
  const groups = new Map();
  [...(plan?.benefits || [])]
    .sort((a, b) => (a.type === b.type ? 0 : a.type === 'Insurance' ? -1 : 1))
    .forEach((b) => {
      const key = b.category || (b.type === 'Insurance' ? 'Insurance covers' : 'Assistance services');
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(b);
    });
  return [...groups.entries()];
}

export const benefitValue = (b) => b?.sumInsured || 'Included';
